import { render, staticRenderFns } from "./SubscriptionUserWatchDuration.vue?vue&type=template&id=1f50ce46&"
import script from "./SubscriptionUserWatchDuration.vue?vue&type=script&lang=js&"
export * from "./SubscriptionUserWatchDuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports